import Cookie from "js-cookie";

// Source of truth for the app theme. The cookie is also read by the pre-paint
// inline script in public/index.html and (optionally) by the SSR server, so
// keep the key and default in sync with those.

export const THEME_COOKIE = "pmtleo-theme";
export const LIGHT = "light";
export const DARK = "dark";

const isValid = (t) => t === LIGHT || t === DARK;

// The embeddable widget (rendered in an iframe on external sites) manages its
// own appearance and must not be influenced by the app's theme cookie.
export const isWidgetRoute = () =>
  typeof window !== "undefined" &&
  (window.location.pathname || "").indexOf("/widgets/") !== -1;

// SSR-safe: no document on the server -> fall back to the default (dark).
export const getTheme = () => {
  if (typeof document === "undefined") return DARK;
  const t = Cookie.get(THEME_COOKIE);
  return isValid(t) ? t : DARK;
};

// Reflect the theme onto <html>. Idempotent, so StrictMode double-invocation
// is harmless.
export const applyTheme = (theme) => {
  if (typeof document === "undefined") return;
  const el = document.documentElement;
  el.dataset.theme = theme;
  el.style.colorScheme = theme;
  // The pre-paint script in index.html sets an inline background on <html> so
  // the first paint is correct. Clear it now that the stylesheet is live, so
  // the token-driven body background propagates to the canvas and stays in
  // sync on later toggles (otherwise the initial color would be stuck).
  el.style.background = "";
};

export const persistTheme = (theme) => {
  Cookie.set(THEME_COOKIE, theme, { expires: 365, path: "/", sameSite: "lax" });
};

export const setTheme = (theme) => {
  const next = isValid(theme) ? theme : DARK;
  applyTheme(next);
  persistTheme(next);
  return next;
};
